import { t } from "ttag";

import {
  RelatedSettingsSection,
  getGuestEmbedsRelatedSettingItems,
} from "metabase/admin/components/RelatedSettingsSection";
import { SettingsPageWrapper } from "metabase/admin/components/SettingsSection";
import { SharedCombinedEmbeddingSettings } from "metabase/admin/settings/components/EmbeddingSettings/SharedCombinedEmbeddingSettings";
import { usePageTitle } from "metabase/hooks/use-page-title";

export function GuestEmbedsSettings() {
  usePageTitle(t`Guest embeds`, { titleIndex: 1 });

  return (
    <SettingsPageWrapper title={t`Guest embeds`}>
      <SharedCombinedEmbeddingSettings />

      <RelatedSettingsSection items={getGuestEmbedsRelatedSettingItems()} />
    </SettingsPageWrapper>
  );
}
